import {createStore, compose, applyMiddleware} from 'redux';
import thunkMiddleware from 'redux-thunk';
import persistState from 'redux-localstorage';
import {routerMiddleware} from 'connected-react-router';
import rootReducer from '../reducers/index';
import initTranslations from '../translations';

let store = null;

function configureStore(history, initialState) {
  const persistedState = localStorage.getItem('redux') ? JSON.parse(localStorage.getItem('redux')) : {};

  const enhancer = compose(
    applyMiddleware(routerMiddleware(history), thunkMiddleware),
    // eslint-disable-next-line
    persistState([], {slicer: paths => state => {
      return {
        organisation: state.organisation ? {organisationId: state.organisation.organisationId} : null,
        i18n: {locale: state.i18n.locale},
        project: state.project,
        display: state.display
      };
    }})
  );

  const initialStore = createStore(rootReducer(history), initialState, enhancer);
  initTranslations(initialStore, persistedState.i18n ? persistedState.i18n.locale : undefined);

  return initialStore;
}

export default {
  init(history) {
    store = configureStore(history);
  },
  getStore() {
    return store;
  }
};
